var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22607 3.75H16.2261C16.6361 3.75 16.9761 3.41 16.9761 3C16.9761 2.59 16.6361 2.25 16.2261 2.25H8.22607C7.81607 2.25 7.47607 2.59 7.47607 3C7.47607 3.41 7.81607 3.75 8.22607 3.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2261 5.25H4.22607C3.81607 5.25 3.47607 5.59 3.47607 6C3.47607 6.41 3.81607 6.75 4.22607 6.75H4.52607L5.22607 17.32C5.39607 19.81 7.47607 21.75 9.96607 21.75H14.4861C16.9761 21.75 19.0561 19.8 19.2261 17.32L19.9261 6.75H20.2261C20.6361 6.75 20.9761 6.41 20.9761 6C20.9761 5.59 20.6361 5.25 20.2261 5.25ZM17.7261 17.22C17.6161 18.92 16.1861 20.25 14.4861 20.25H9.96607C8.25607 20.25 6.83607 18.92 6.72607 17.22L6.02607 6.75H18.4261L17.7261 17.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2261 17.75C12.6361 17.75 12.9761 17.41 12.9761 17V10C12.9761 9.59 12.6361 9.25 12.2261 9.25C11.8161 9.25 11.4761 9.59 11.4761 10V17C11.4761 17.41 11.8161 17.75 12.2261 17.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2261 17.75C15.6361 17.75 15.9761 17.41 15.9761 17V10C15.9761 9.59 15.6361 9.25 15.2261 9.25C14.8161 9.25 14.4761 9.59 14.4761 10V17C14.4761 17.41 14.8161 17.75 15.2261 17.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22607 17.75C9.63607 17.75 9.97607 17.41 9.97607 17V10C9.97607 9.59 9.63607 9.25 9.22607 9.25C8.81607 9.25 8.47607 9.59 8.47607 10V17C8.47607 17.41 8.81607 17.75 9.22607 17.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.7fddf0bad70786d7a792e59a99afef52.svg";
export { ForwardRef as ReactComponent };